import React from 'react';
import { useState } from 'react';
import { Grid } from '@mui/material';
import { DataGrid, GridEventListener } from '@mui/x-data-grid';
import useStore from '../../store/useStore';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';


const ListViewEvents = () => {
  // Set Local state
  const [popoverState, setPopoverState] = useState({
    anchor: null,
    content: null,
  });

  // Get global State slices
  const { gridData, gridOptions, loading } = useStore((state: any) => ({
    gridData: state.MUIdataEvents,
    gridOptions: state.gridOptions,
    loading: state.loading,
  }));

  // Popover functions
  const handlePopoverOpen = (event: any) => {
    const field = event.currentTarget.dataset.field;
    const id = event.currentTarget.parentElement.dataset.id;
    const row: any = gridData.rows.find((r: any) => String(r.id) === id);
    if (field !== 'picture' && row[field] !== undefined && row[field] !== '') {
      setPopoverState({ content: row[field], anchor: event.currentTarget });
    }
  };

  const handlePopoverClose = () => {
    setPopoverState({ anchor: null, content: null });
  };

  const open = Boolean(popoverState.anchor);

  const handleRowClick: GridEventListener<'rowClick'> = (params) => {
    window.open(params.row.EventURL);
  };

  // Get pagination information from state
  const { currentEventPage, eventsPerPage, changeCurrentEventPage } = useStore((state: any) => ({
    currentEventPage: state.currentEventPage,
    eventsPerPage: state.eventsPerPage,
    changeCurrentEventPage: state.changeCurrentEventPage,
  }));

  //calculate pagination slice interval
  const indexOfLastPost = currentEventPage * eventsPerPage;
  const indexOfFirstPost = indexOfLastPost - eventsPerPage;

  //slice rows to get paginated posts
  const paginatedRows = gridData.rows.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    changeCurrentEventPage(value);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <div className="ituContainer">

        <Grid container style={{ width: '100%', height: '950px', margin: '3rem auto 0' }}>
          <Grid item xs={12}>
            <DataGrid
              columns={gridData.columns}
              rows={paginatedRows}
              pageSize={eventsPerPage}
              hideFooterPagination={true}
              hideFooter={true}
              components={{
              }}
              loading={loading}
              onRowClick={handleRowClick}
              componentsProps={{
                cell: {
                  onMouseEnter: handlePopoverOpen,
                  onMouseLeave: handlePopoverClose,
                },
              }}
            />
          </Grid>
        </Grid>

        {gridData.rows.length > eventsPerPage ? (

          <Grid item xs={12}>
            <Stack spacing={2}>
              <Pagination count={Math.ceil(gridData.rows.length / eventsPerPage)} page={currentEventPage} onChange={handlePageChange} style={{
                justifyContent: "center",
                display: 'flex',
                marginTop: "1rem"
              }} />
            </Stack>
          </Grid>
        ) : null
        }
      </div>
    </>

  );
};

export default ListViewEvents;
